























import { defineComponent, computed, ref } from "@vue/composition-api";
import Announcements from "./Organisms/Announcements/index.vue";
import AttentionReviews from "./Organisms/AttentionReviews/index.vue";
import CompanyRanks from "./Organisms/CompanyRanks/index.vue";
import JobEvents from "./Organisms/JobEvents/index.vue";
import ComingEvents from "./Organisms/ComingEvents/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import OnboardingFloatingView from "@/components/Organisms/OnboardingFloatingView";
import { useCalendarReviewApproved } from "@/helpers/hooks/useCalendarReviewApproved";

export default defineComponent({
  name: "Dashboard",
  components: {
    LoadingView,
    Announcements,
    AttentionReviews,
    CompanyRanks,
    JobEvents,
    ComingEvents,
    OnboardingFloatingView
  },
  setup() {
    const announcementLoading = ref(false);
    const attentionReviewsLoading = ref(false);
    const jobEventsLoading = ref(false);
    const comingEventsLoading = ref(false);
    const isLoading = computed(() => {
      return (
        announcementLoading.value ||
        attentionReviewsLoading.value ||
        jobEventsLoading.value ||
        comingEventsLoading.value
      );
    });

    const { isCalendarReviewApproved } = useCalendarReviewApproved();

    return {
      isLoading,
      announcementLoading,
      attentionReviewsLoading,
      jobEventsLoading,
      comingEventsLoading,
      isCalendarReviewApproved
    };
  }
});
